document.addEventListener("DOMContentLoaded", () => {
  console.log("video hidden");
  const videoContainers = document.querySelectorAll(
    ".hidden-before-load-video"
  );

  videoContainers.forEach((container) => {
    const video = container.querySelector("video");

    // Проверяем состояние видео
    const checkVideoState = () => {
      if (video.readyState >= 3) {
        // HAVE_FUTURE_DATA
        container.classList.add("hidden-before-load-video--active");
      }
    };

    // Проверяем сразу на случай быстрой загрузки
    checkVideoState();

    // Слушаем события загрузки
    video.addEventListener("loadeddata", checkVideoState);
    video.addEventListener("canplay", checkVideoState);

    // На случай ошибки тоже показываем контейнер
    video.addEventListener("error", () => {
      container.classList.add("hidden-before-load-video--active");
    });
  });
});
